import { FC } from 'react';
import { AutoplayControlBar } from './AutoplayControlBar';
import { AutoplayStartModal } from './AutoplayStartModal';
import { useAutoplayController } from './useAutoplayController';

/**
 * Single mount point for dashboard autoplay: the session timers have to outlive every dashboard
 * swap, so they hang off this component rather than off the control bar it renders.
 */
export const DashboardAutoplay: FC = () => {
  useAutoplayController();

  return (
    <>
      <AutoplayControlBar />
      <AutoplayStartModal />
    </>
  );
};
